export default __webpack_public_path__ + "static/pqcode-e24460dc53ba5e0e022ea6301ef6c557.png";